// 创建 Redux State Slice
// 在该文件中，从 Redux Toolkit 导入 createSlice API。
// 创建 slice 需要一个字符串名称来标识 slice，一个初始 state 值，以及一个或多个 reducer 函数来定义如何更新 state。创建 slice 后，我们可以导出生成的 Redux action creators 和整个 slice reducer 函数。

import { createSlice } from '@reduxjs/toolkit';

export const elementState = createSlice({
  name: 'elementState',
  initialState: {
    Navbar: {
        Height:30,
    },
  },
  reducers: {
    // 改值
    change: (state, data) =>{
        state.Navbar.Height = data.payload // 
    }
  },
});

// 为每个 case reducer 函数生成 Action creators
export const { change } = elementState.actions;

export default elementState.reducer;